export default "__VITE_ASSET__tHk3uT1X__"